/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCourseAddPost } from '../fn/course/api-master-course-add-post';
import { ApiMasterCourseAddPost$Params } from '../fn/course/api-master-course-add-post';
import { apiMasterCourseDeleteGet } from '../fn/course/api-master-course-delete-get';
import { ApiMasterCourseDeleteGet$Params } from '../fn/course/api-master-course-delete-get';
import { apiMasterCourseEditPost } from '../fn/course/api-master-course-edit-post';
import { ApiMasterCourseEditPost$Params } from '../fn/course/api-master-course-edit-post';
import { apiMasterCourseGetActiveGet } from '../fn/course/api-master-course-get-active-get';
import { ApiMasterCourseGetActiveGet$Params } from '../fn/course/api-master-course-get-active-get';
import { apiMasterCourseGetAllGet } from '../fn/course/api-master-course-get-all-get';
import { ApiMasterCourseGetAllGet$Params } from '../fn/course/api-master-course-get-all-get';
import { apiMasterCourseGetByCriteriaPost } from '../fn/course/api-master-course-get-by-criteria-post';
import { ApiMasterCourseGetByCriteriaPost$Params } from '../fn/course/api-master-course-get-by-criteria-post';
import { apiMasterCourseInActiveGet } from '../fn/course/api-master-course-in-active-get';
import { ApiMasterCourseInActiveGet$Params } from '../fn/course/api-master-course-in-active-get';
import { Course } from '../models/course';
import { CourseApiRespModel } from '../models/course-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CourseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCourseAddPost()` */
  static readonly ApiMasterCourseAddPostPath = '/api/Master/Course/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseAddPost$Response(params?: ApiMasterCourseAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseApiRespModel>> {
    return apiMasterCourseAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseAddPost(params?: ApiMasterCourseAddPost$Params, context?: HttpContext): Observable<CourseApiRespModel> {
    return this.apiMasterCourseAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseApiRespModel>): CourseApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseEditPost()` */
  static readonly ApiMasterCourseEditPostPath = '/api/Master/Course/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseEditPost$Response(params?: ApiMasterCourseEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseApiRespModel>> {
    return apiMasterCourseEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseEditPost(params?: ApiMasterCourseEditPost$Params, context?: HttpContext): Observable<CourseApiRespModel> {
    return this.apiMasterCourseEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseApiRespModel>): CourseApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseDeleteGet()` */
  static readonly ApiMasterCourseDeleteGetPath = '/api/Master/Course/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseDeleteGet$Response(params?: ApiMasterCourseDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterCourseDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseDeleteGet(params?: ApiMasterCourseDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterCourseDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseInActiveGet()` */
  static readonly ApiMasterCourseInActiveGetPath = '/api/Master/Course/InActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseInActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseInActiveGet$Response(params?: ApiMasterCourseInActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterCourseInActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseInActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseInActiveGet(params?: ApiMasterCourseInActiveGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterCourseInActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseGetAllGet()` */
  static readonly ApiMasterCourseGetAllGetPath = '/api/Master/Course/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseGetAllGet$Response(params?: ApiMasterCourseGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Course>>> {
    return apiMasterCourseGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseGetAllGet(params?: ApiMasterCourseGetAllGet$Params, context?: HttpContext): Observable<Array<Course>> {
    return this.apiMasterCourseGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Course>>): Array<Course> => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseGetActiveGet()` */
  static readonly ApiMasterCourseGetActiveGetPath = '/api/Master/Course/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseGetActiveGet$Response(params?: ApiMasterCourseGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Course>>> {
    return apiMasterCourseGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseGetActiveGet(params?: ApiMasterCourseGetActiveGet$Params, context?: HttpContext): Observable<Array<Course>> {
    return this.apiMasterCourseGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Course>>): Array<Course> => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseGetByCriteriaPost()` */
  static readonly ApiMasterCourseGetByCriteriaPostPath = '/api/Master/Course/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseGetByCriteriaPost$Response(params?: ApiMasterCourseGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Course>>> {
    return apiMasterCourseGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseGetByCriteriaPost(params?: ApiMasterCourseGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Course>> {
    return this.apiMasterCourseGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Course>>): Array<Course> => r.body)
    );
  }

}
